import { render, staticRenderFns } from "./endotoxinas_cnsr.vue?vue&type=template&id=c055967e&scoped=true"
import script from "./endotoxinas_cnsr.vue?vue&type=script&lang=js"
export * from "./endotoxinas_cnsr.vue?vue&type=script&lang=js"
import style0 from "./endotoxinas_cnsr.vue?vue&type=style&index=0&id=c055967e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c055967e",
  null
  
)

export default component.exports